import { Injectable } from '@angular/core';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { ModalDataType } from '../../../vass-core/components/modal/modal-data-type.interface';
import { LoginComponent } from '../../components/login/login.component';

@Injectable()
export class CommonService {
  constructor(private confirmationService: ConfirmationService) {}

  openModalLogin(isRegister: boolean, openFromHeader?: boolean) {
    let titleModal = 'Continuar solicitud en curso';
    if (isRegister) {
      titleModal = 'Introduce tus datos para continuar con la simulación';
    }

    const options: Object = {
      txtButton: '',
      showHeader: true,
      header: titleModal,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<ModalDataType>{
      component: LoginComponent,
      options: options,
      data: {
        isRegister: isRegister,
        openFromHeader: openFromHeader,
      },
      accept: (data) => {},
      reject: () => {},
    });
  }
}
